import {css} from '@emotion/react';

const TrustedBrandStyles = css({
    ".desktop":{userDrag: 'none',MozUserSelect: 'none',WebkitUserDrag: 'none',},
    ".mobile":{paddingLeft:"10%",paddingRight:"10%",userDrag: 'none',MozUserSelect: 'none',WebkitUserDrag: 'none',},
});

export default TrustedBrandStyles;